import {
  B2BProducts,
  B2BMFAProducts,
  AuthFlowType,
  StytchB2BUIConfig,
  B2BOAuthProviders,
} from '@stytch/nextjs/b2b'
import { STYTCH_ACTIVE_SESSION_DURATION, getSharedRedirectURL } from './config'

const STYTCH_CLIENT_EMAIL_TEMPLATE_IDS = {
  login: 'client_portal_login',
  invite: 'client_portal_user_invite',
  resetPassword: 'client_portal_password_reset', // NOSONAR
}
export const getOrganizationConfig = (): StytchB2BUIConfig => {
  const redirectURL = getSharedRedirectURL()

  return {
    products: [B2BProducts.emailMagicLinks, B2BProducts.passwords, B2BProducts.oauth],
    sessionOptions: { sessionDurationMinutes: STYTCH_ACTIVE_SESSION_DURATION },
    mfaProductInclude: [B2BMFAProducts.totp, B2BMFAProducts.smsOtp],
    mfaProductOrder: [B2BMFAProducts.totp, B2BMFAProducts.smsOtp],
    emailMagicLinksOptions: {
      loginRedirectURL: redirectURL,
      signupRedirectURL: redirectURL,
      loginTemplateId: STYTCH_CLIENT_EMAIL_TEMPLATE_IDS.login,
      signupTemplateId: STYTCH_CLIENT_EMAIL_TEMPLATE_IDS.invite,
    },
    passwordOptions: {
      loginRedirectURL: redirectURL,
      resetPasswordRedirectURL: redirectURL,
      resetPasswordTemplateId: STYTCH_CLIENT_EMAIL_TEMPLATE_IDS.resetPassword,
    },
    oauthOptions: {
      loginRedirectURL: redirectURL,
      signupRedirectURL: redirectURL,
      discoveryRedirectURL: redirectURL,
      providers: [B2BOAuthProviders.Google],
    },
    authFlowType: AuthFlowType.Organization,
  }
}
